import { render, staticRenderFns } from "./WM2.vue?vue&type=template&id=8cde8b46&scoped=true&"
import script from "./WM2.vue?vue&type=script&lang=js&"
export * from "./WM2.vue?vue&type=script&lang=js&"
import style0 from "./WM2.vue?vue&type=style&index=0&id=8cde8b46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cde8b46",
  null
  
)

export default component.exports